<script setup lang="ts">
import { BadgeCheck } from 'lucide-vue-next'

const features = [
  {
    text: 'У нас нет скрытых комиссий, пеней и штрафов, условия прозрачны и прописаны в договоре',
  },
  {
    text: 'Выдаем займы даже клиентам с плохой кредитной историей',
  },
  {
    text: 'Мы не требуем документального подтверждения работы и дохода',
  },
  {
    text: 'Не просим оставить имущество в залог и привести поручителей',
  },
  {
    text: 'Вам не нужно отчитываться о том, на что Вы потратили деньги',
  },
  {
    text: 'Вы можете погасить заем досрочно, внеся очередной платеж по графику',
  },
]
</script>

<template>
  <section id="whyclients" class="py-16 bg-white">
    <div class="container mx-auto px-4">
      <!-- Заголовок -->
      <div class="text-center md:mb-6">
        <h2>Почему клиенты </h2>
        <h2 class="text-3xl font-bold text-title mb-4">
          Выбирают нас
        </h2>
      </div>

      <!-- Сетка преимуществ -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 md:gap-4">
        <div
          v-for="(feature, index) in features"
          :key="index"
          class="p-2 md:p-6 md:pt-4 rounded-xl transition-all relative"
        >
          <div class="flex flex-col  items-center gap-1 justify-center">
            <!-- Иконка -->
            <div class="flex-shrink-0 p-3 rounded-lg text-[#00A1DD]">
              <BadgeCheck class="w-6 h-6" />
            </div>

            <!-- Текст -->
            <div>
              <p class="text-gray-600 leading-relaxed text-center">
                {{ feature.text }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ReadyClient />
  </section>
</template>

<style scoped>

</style>
